module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/mnt/metabase_42/metabase2/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/mnt/metabase_42/metabase2/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}